"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loadAccountPreferencesModule = () => ({
    hasRouter: false,
    modules: [],
});
exports.default = loadAccountPreferencesModule;
